<template>
  <div>
    <md-table md-card v-model="list_data.mdData" >
      <p class="md-caption">
        EL años fiscal seleccionado es colocado por defecto en las operaciones.</p>
      <md-table-toolbar>
        <h1 class="md-title">Año fiscal
        </h1>
        <md-menu md-size="big" md-direction="bottom-end">
          <md-button class="md-icon-button" @click="go_to('/')">
            <md-icon>keyboard_backspace</md-icon>
          </md-button>
        </md-menu>
        <md-menu md-size="big" md-direction="bottom-end">
          <md-button class="md-icon-button" @click="go_to('/fiscal_year')">
            <md-icon>add</md-icon>
          </md-button>
        </md-menu>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head >Año</md-table-head>
        <md-table-head >Fecha inicio</md-table-head>
        <md-table-head >Fecha fin</md-table-head>
        <md-table-head >Estado</md-table-head>
        <md-table-head >Selecionar</md-table-head>
        <md-table-head >Periodos</md-table-head>
      </md-table-row>
      <md-table-row v-for="(item, index) in list_data.mdData" :key="item.id">
        <md-table-cell >
        <md-badge v-if="item.id === year_selected"
        class="md-square md-accent" md-content="Elegido" >
        <p>{{ item.year }}</p>
        </md-badge>
        <span v-else>{{ item.year }}</span>
      </md-table-cell>
        <md-table-cell>{{ item.initial_date|to_date }}</md-table-cell>
        <md-table-cell>{{ item.final_date|to_date }}</md-table-cell>
        <md-table-cell>{{ item.open_state|status_to_text }}</md-table-cell>
        <md-table-cell title="Click para elegir este año fiscal">
          <md-button class="md-icon-button md-primary" @click="set_fiscal_year(item, index)">
            <md-icon class="md-size-2x" >done</md-icon>
          </md-button>
        </md-table-cell>
        <md-table-cell >
          <md-button class="md-icon-button" @click="get_list_periods(item, index)">
            <md-icon class="md-size-1x" >call_made</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
      <md-table-pagination
        :md-page-size="rowsPerPage"
        :md-page-options="[3, 5, 10, 15]"
        :md-update="list"
        :md-paginated-data.sync="list_data" />
    </md-table>
    <md-empty-state
      md-icon="free_breakfast" v-if="list_data.mdData.length === 0"
      md-label="Crear un año fiscal"
      md-description="Aún no hay un año fiscal registrado, crea el primero.">
      <md-button @click="go_to('/fiscal_year')"
      md-theme="blue-button" class="md-accent md-raised">Crear año fiscal</md-button>
    </md-empty-state>
    <md-progress-bar md-mode="indeterminate" v-if="sending_request" />
    <br>
    <br>
    <br>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Filtros</md-dialog-title>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field >
              <label for="name_field">Campo</label>
              <md-select v-model="filters.name_field"
              :disabled="sending"
              >
                <md-option :value="item.value"
                v-for="(item, key) in choosen_field"
                :key="key">{{item.text}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field >
              <label for="name_field">Criterio</label>
              <md-select v-model="filters.criterio"
              :disabled="sending"
              >
                <md-option :value="item.value"
                v-for="(item, key) in choosen_criterio"
                :key="key">{{item.text}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field >
              <label for="term">Termino a buscar</label>
              <md-input
              v-model="filters.termino" type="text" :disabled="sending" />
            </md-field>
          </div>
        </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Cerrar</md-button>
        <md-button class="md-primary" @click="list(1, rowsPerPage) ">Filtrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog :md-active.sync="showDialogPeriodos">
      <md-dialog-title>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-30">
            Periodos: {{lista_periods.length}}
          </div>
          <div class="md-layout-item md-small-size-60 md-size-50">
            Año fiscal: {{instance.year}} <small v-if="instance.open_state" >
              <a href="#" @click.prevent="saveOrUpdate()">Cerrar</a></small>
          </div>
          <div class="md-layout-item md-small-size-10">
            <md-menu md-size="big" md-direction="bottom-end">
              <md-button class="md-icon-button" @click="showDialogPeriodos = false">
                <md-icon>close</md-icon>
              </md-button>
            </md-menu>
          </div>
        </div>
      </md-dialog-title>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-table v-model="lista_periods" >
              <md-table-row>
                <md-table-head class="md-xsmall-hide md-small-hide">#</md-table-head>
                <md-table-head>Periodo</md-table-head>
                <md-table-head >Fecha perido</md-table-head>
              </md-table-row>
              <md-table-row v-for="(item, index) in lista_periods" :key="item.id">
                <md-table-cell class="md-xsmall-hide md-small-hide" >{{index + 1}}</md-table-cell>
                <md-table-cell  md-sort-by="period">{{ item.period }}</md-table-cell>
                <md-table-cell>{{ item.date|to_date }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialogPeriodos = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-snackbar
      :md-active.sync="alert">{{ message }}</md-snackbar>
  </div>
</template>
<script>
import moment from 'moment';
/* eslint-disable */
export default {
  name: 'Año_fiscal_lista',
  created(){
    let current_filters = this.get_data_storage('filters_courses')
    if(current_filters){
      this.filters = current_filters
    }
    let year_selected_storage =this.get_data_storage_raw('id_fiscal_year')
    if (year_selected_storage) {
      this.year_selected = year_selected_storage
    }
    this.list(1, this.rowsPerPage)
  },
  data() {
    return {
      year_selected: null,
      filters: {},
      lista_periods: [],
      list_data: {
        mdCount: null,
        mdPage: null,
        mdData: []
      },
      instance: {},
      sending: false,
      showDialog: false,
      showDialogPeriodos: false,
      show_list: true,
      alert: false,
      message: null,
      rowsPerPage: 10,
      filters: {
        bimestre: '',
      },
      url: 'fiscal_year/',
      url_periods: 'periods/',
      sending_request: false,
      choosen_field: [
        {value:'customer__juridica__name', text: 'Cliente'},
        {value:'fecha', text: 'Fecha'},
        {value:'amount', text: 'Total'},
        {value:'type_document', text: 'Tipo docuemnto'},
        {value:'iva', text: 'Iva'},
      ],
      choosen_criterio: [
        {value:'=', text: 'Igual'},
        {value:'>', text: 'Mayor'},
        {value:'<', text: 'Menor'},
        {value:'!=', text: 'Diferente'},
      ]
    };
  },
  methods: {
    saveOrUpdate () {
      const payload = this.instance
      const self = this
      payload.open_state = "False"

      this.sending_request = true
      console.log("fea..", this.instance)
      if (this.instance.id) {
        this.putRequest(this.url, payload).then(function (data) {
          self.message = `Año fiscal ${self.instance.year} actualizado`
          self.alert = true
          self.sending_request = false
          self.$set(self.list_data.mdData, self.instance.index, data.data)
          self.instance = data.data
        }).catch(function (error) {
          self.sending_request = false
          if (typeof (error.response.data) === 'object') {
            const result = error.response.data
            Object.entries(result).forEach(
              ([key, value]) => self.$swal.fire('Error!', key + ': ' + value, 'error')
            )
            return false
          }
          self.$swal.fire('Error!', error.response.data, 'error')
        })
        return
      }
    },
    go_to(url) {
      this.$router.push(url);
    },
    save_storage(key, data) {
      localStorage.setItem([key], JSON.stringify(data));
    },
    save_storage_raw(key, data) {
      localStorage.setItem([key], data);
    },
    remove_storage(key) {
      localStorage.removeItem([key]);
    },
    get_data_storage(name) {
      return JSON.parse(localStorage.getItem(name));
    },
    get_data_storage_raw(name) {
      return localStorage.getItem(name);
    },
    set_fiscal_year (instance) {
      this.remove_storage('id_fiscal_year')
      this.save_storage_raw('id_fiscal_year', instance.id)
      let libro = this.get_data_storage_raw('id_fiscal_year')
      if (libro){
        this.$swal.fire('Seleccionado!', 'El año fiscal '+instance.year+' ha sido seleccionado.', 'success')
        return false
      }
      this.$swal.fire('Error!', 'Paso algo y el año fiscal no fue elegido.', 'error')

    },
    reset_filters: function () {
      this.filters = {}
      this.remove_storage('filters_courses')
      this.list()
    },
    get_list_periods(obj, index) {
      this.instance = obj
      this.instance.index = index
      let payload = {};
      payload.fiscal_year = obj.id
      const self = this;
      if (this.sending_request) return false
      this.sending_request = true
      this.sendRequest_with_url(this.url_periods, payload).then((data) => {
        this.lista_periods = data.data
        this.showDialogPeriodos = true
        this.sending_request = false
      }).catch((error) => {
        self.sending_request = false
        self.handlerError(error)
      });
      return null;
    },
    list(page, pageSize, sort, sortOrder) {
      let payload = {};
      const self = this;
      payload.paginate = "True"
      payload.page = page
      payload.per_page = pageSize
      if (this.sending_request) return false
      this.sending_request = true

      this.sendRequest_with_url(this.url, payload).then((data) => {
        self.sending_request = false
        self.rowsPerPage = 50
        self.list_data = {
          mdCount: data.data.count,
          mdPage: page,
          mdData: data.data
        }
        // self.save_storage('filters_courses', self.filters,)
      }).catch((error) => {
        self.sending_request = false
        self.handlerError(error)
      });
      return null;
    },
    async sendRequest(payload) {
      const result = await this.$http.get(this.url,{params:  payload});
      return result;
    },
    async sendRequest_with_url(url, payload) {
      const result = await this.$http.get(url,{params:  payload});
      return result;
    },
    handlerError: function (error) {
      if (typeof (error.response.data) === 'object') {
        const result = error.response.data
        Object.entries(result).forEach(
          ([key, value]) => this.$swal.fire('Error!', key + ': ' + value, 'error')
        )
        return false
      }
      this.$swal.fire('Error!', error.response.data, 'error')
    },
    async putRequest (url, payload) {
      const result = await this.$http.put(`${url}${payload.id}/`, payload)
      return result
    },
  },
  filters: {
    status_to_text(value){
      if (value) return 'ABIERTO';
      return 'CERRADO';
    },
    to_date(value) {
      if (!value ) return '-----'
      return moment(value, 'YYYY-MM-DD', 'es').format('ll')
    },
  },
};

</script>
<style lang="scss" scoped>
  .md-table + .md-table {
    margin-top: 16px
  }
  .avatar img {
    max-width: 30px;
  }
</style>
<style lang="css" scoped>
  .on-over {
    cursor: pointer;
  }
  .fa-refresh {
      -webkit-animation: infinite-spinning 5s normal linear infinite;
      animation: infinite-spinning 5s normal linear infinite;
  }
  .null{
    text-decoration: line-through;
  }
  .fade-enter-active {
    transition: all .5s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
  .md-dialog-container .md-layout{
    overflow-y: auto !important;
  }

  @keyframes infinite-spinning {
    0% {
       -webkit-transform: rotate3d(0, 0, 1, 0deg);
       transform: rotate3d(0, 0, 1, 0deg);
     }
     25% {
       -webkit-transform: rotate3d(0, 0, 1, 90deg);
       transform: rotate3d(0, 0, 1, 90deg);
     }
     50% {
       -webkit-transform: rotate3d(0, 0, 1, 180deg);
       transform: rotate3d(0, 0, 1, 180deg);
     }
     75% {
       -webkit-transform: rotate3d(0, 0, 1, 270deg);
       transform: rotate3d(0, 0, 1, 270deg);
     }
     100% {
       -webkit-transform: rotate3d(0, 0, 1, 360deg);
       transform: rotate3d(0, 0, 1, 360deg);
     }
  }
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
